import { createBrowserHistory } from 'history';

const history = createBrowserHistory({ forceRefresh: true });

// You can export the custom history object to use it throughout your app
export default history;